import "./AcoeNote1.css";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

function CoeNote1() {

  const [scholarDetails, setScholarDetails] = useState(null);
  const [adjudicatorDetails, setAdjudicatorDetails] = useState(null);
  const [educationDetails, setEducationDetails] = useState(null);
  const [fileForVC, setFileForVC] = useState("");
  const [approve, setApprove] = useState(false);

  const loc = useLocation();
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != loc.state.officer) {
      alert("unauthorized to this page")
      logout();
    }
    var data = {
      scholarId: loc.state.id,
      note: loc.state.note
    }
    axios
      .post("/api/get-bospanel-note-pages", data)
      .then((resData) => {
        setScholarDetails(resData.data.panel_data);
        setAdjudicatorDetails(resData.data.adjuticators_data);       
        setEducationDetails(resData.data.education_details);
      })
      .catch((e) => {
        alert("can't find bos details");
      });

  }, []);

  const handleFileUpload = async (file) => {
    let form_data = new FormData();
    form_data.append("file", file);
    form_data.append("file_name", "panel_file");
    form_data.append("mobile", loc.state.id);
    try {
      const resData = await axios.post("/api/file-upload", form_data);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
        setFileForVC(resData.data["file-name"])
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function handleSubmit() {
    let reqData = {
      scholarId: loc.state.id,
      status: approve ? "APPROVED" : "REJECTED",
      fileForVC,
      designation: Cookies.get("username"),
      note: loc.state.note
    }
    try {
      const resData = await axios.post("/api/update-bospanel", reqData);
      if (resData.status === 200) {
        console.log(resData.data["file-name"]);
      } else {
        console.log(resData);
      }
    } catch (e) {
      console.log(e);
    }
    alert("success");
  }

  const handleApproveOrReject = (e) => {
    if (e.target.value === "true") {
      document.getElementById("approve").checked = true;
      document.getElementById("reject").checked = false;
      setApprove(true);
    } else {
      document.getElementById("approve").checked = false;
      document.getElementById("reject").checked = true;
      setApprove(false);
    }
  };

  return (
    <>
      {(scholarDetails === null || educationDetails === null || adjudicatorDetails === null) ? (
        <center>
          <RotateLeftIcon
            sx={{
              fontSize: "3rem",
              margin: "0 auto",
              color: "rgba(0,0,0,0.6)",
              animation: "spin 1s linear infinite",
              "@keyframes spin": {
                "0%": {
                  transform: "rotate(360deg)",
                },
                "100%": {
                  transform: "rotate(0deg)",
                },
              },
            }}
          />{" "}
          Loading Details
        </center>
      ) : (
        <>
          <br />
          <br />
          <center>
            <>
              <div className="whole-body" >
                <br />
                <h1>KAKATIYA UNIVERSITY</h1>
                <hr />
                <div font-size="15">
                  <table className="page-header">
                    <tr>
                      <td>SUBJECT :</td>
                      <td>
                        <b> {scholarDetails.subject} </b>-Ph.D.thesis submitted by{" "}
                        <b>Mr/Ms. {scholarDetails.name_of_scholar} -</b> Appointment of{" "}
                        <b>
                          <i>Three Examiners</i>
                        </b>{" "}
                        for Evaluation-Reg.
                      </td>
                    </tr>
                  </table>
                </div>
                <hr />
                <div className="main-content">
                  <b>Mr/Ms. {scholarDetails.name_of_scholar}, </b>Research Scholar in<b> {scholarDetails.subject} </b>
                  , {educationDetails.name_ofiversity} has registered for the degree of Ph.D. in{" "}
                  <b> {scholarDetails.subject} </b> during the year objyearofadd. He/She Worked
                  under the supervision of <b>{educationDetails.name_of_supervisor}, {educationDetails.name_ofiversity}</b>.
                  He/She has passed Pre-Ph.D
                  <b> {scholarDetails.subject} </b>, during {educationDetails.month_year_passing} .
                  <br />
                  <br />
                  <b>Mr/Ms. {scholarDetails.name_of_scholar}, </b> has now submitted his Ph.D. thesis
                  entitled
                  <b> " {scholarDetails.title} ", </b>for evaluation to award the Ph.D. Degree of
                  Kakatiya University.
                  <br />
                  <br /> The Panel of examiners for evaluation of Ph.D.thesis is
                  received from<b> the Chairperson</b>
                  , Board of Studies in <b> {scholarDetails.subject} </b> Kakatiya University.
                </div>
                <br />
                <br />
                <div className="examinars">
                  <b>Three Examiners</b> may please be appointed from the following:
                  <br />
                  <br />
                  <b>
                    <u>One Examiner from S.No.1 to 3</u>
                  </b>

                  <br />
                  <ol>
                    {adjudicatorDetails.slice(0, 3).map((obj) => {
                      return (
                        <li key={obj.mobile}>
                          {obj.name}, {obj.name_of_university}, <b> {obj.state}</b>.
                        </li>
                      )
                    })}
                  </ol>
                  <b>
                    <u>Two Examination from S.No.4 to 9</u>
                  </b>
                  <ol start="4">
                    {adjudicatorDetails.slice(3, 9).map((obj) => {
                      return (
                        <li key={obj.mobile}>
                          {obj.name}, {obj.name_of_university}, <b> {obj.state}</b>.
                        </li>
                      )
                    })}
                  </ol>
                  <b>File for VC</b>
                  <br />
                  <a href={axios.defaults.baseURL + "api" + scholarDetails.panel_file} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                </div>
                <div>
                  <input
                    onClick={handleApproveOrReject.bind(this)}
                    type="radio"
                    id="approve"
                    defaultChecked={approve ? true : false}
                    style={{ marginRight: 10 }}
                    value="true"
                    required
                  />
                  <label>Approve</label>
                  <input
                    onClick={handleApproveOrReject.bind(this)}
                    type="radio"
                    id="reject"
                    defaultChecked={!approve ? true : false}
                    style={{ marginLeft: 10, marginRight: 10 }}
                    value="false"
                    required
                  />
                  <label>Reject</label>
                </div>
                <br />
                <br />
                <br />
                <div>
                  <input onClick={handleSubmit} className="btn btn-secondary" required />
                </div>
                <br />
                <br />
                <br />
              </div>
            </>
          </center>
          <br />
          <br />
        </>
      )}
    </>
  )
}
export default CoeNote1;
function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/officers-login";
}